export enum routeParams {
  projectId = 'projectId',
}

export const routeToMainPage = `:${routeParams.projectId}`;
export const routeToEditPage = 'edit';
export const routeToMembersPage = 'members';
export const routeToPermissionRequestsPage = 'permission-requests';
